export default {
  isFocused: false,
  shrink: false
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-ui-superselectfield/es/defaultProps/floatingLabel.defaultProps.js
// module id = 1694
// module chunks = 0